import { z } from 'zod';
const id = z.string().min(1).max(120);
const revision = z.string().regex(/^[a-f0-9]{64}$/);
export const fieldJourneySchema = z.enum(['knowledge', 'trade', 'recovery', 'synthetic_cohort']);
export const fieldCompanyControlsSchema = z.object({
    holds: z.array(z.object({
        id,
        prId: id,
        revision,
        actorId: z.literal('elena'),
        reason: z.string(),
        status: z.enum(['active', 'resolved']),
        evidence: z.array(z.object({ id, revision: z.string() })),
        createdAt: z.string(),
        resolution: z
            .object({ revision, runId: id, rationale: z.string(), resolvedAt: z.string() })
            .nullable(),
    })),
    acceptances: z.array(z.object({
        id,
        prId: id,
        revision,
        actorId: z.enum(['jordan', 'marcus']),
        journey: fieldJourneySchema,
        runId: id,
        rationale: z.string(),
        observation: z.literal('isolated_protocol_controller'),
        limitations: z.string(),
        createdAt: z.string(),
    })),
    actions: z.array(z.object({
        id,
        prId: id,
        revision,
        actorId: z.literal('amara'),
        action: z.enum(['release', 'pause', 'rollback']),
        reason: z.string(),
        runId: id.nullable(),
        scope: z.literal('synthetic_cohort_registry'),
        createdAt: z.string(),
    })),
});
